if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class extends HTMLElement {
      connectedCallback() {
        if (!window.matchMedia('(max-width: 767px)').matches) return;

        this._sentinel = document.createElement('div');
        this._sentinel.setAttribute('aria-hidden', 'true');
        this._sentinel.style.cssText = 'height:0;overflow:hidden;pointer-events:none;';

        this._ghost = document.createElement('div');
        this._ghost.className = 'sticky-atc-ghost';
        this._ghost.hidden = true;

        // DOM order: ghost → sentinel → sticky-atc (natural position)
        this.before(this._ghost, this._sentinel);

        this._observer = new IntersectionObserver(
          ([entry]) => {
            const isFixed = !entry.isIntersecting && entry.boundingClientRect.top > 0;
            this.classList.toggle('is-fixed', isFixed);
            this._ghost.hidden = !isFixed;
            if (isFixed) this._ghost.style.height = this.offsetHeight + 'px';
          },
          { threshold: 0 }
        );

        this._observer.observe(this._sentinel);
      }

      disconnectedCallback() {
        this._observer?.disconnect();
        this._ghost?.remove();
        this._sentinel?.remove();
      }
    }
  );
}
